import { getRandomDefaultImage } from '@/lib/utils/getRandomImage';

import type { TrackCollection, UserPlaylist } from './types';

const VIRTUAL_PLAYLIST_I18N = {
  'favorite-tracks': 'B2B_favorite_tracks_title',
  'recent-tracks': 'B2B_recent_tracks_title',
} as const;

type VirtualPlaylistId = keyof typeof VIRTUAL_PLAYLIST_I18N;

const buildVirtualPlaylist = (
  id: VirtualPlaylistId,
  t: (key: string) => string,
): TrackCollection => ({
  type: 'library',
  title: t(VIRTUAL_PLAYLIST_I18N[id]),
  id,
  imagePath: getRandomDefaultImage(),
});

export const buildTrackVirtualPlaylists = (
  t: (key: string) => string,
  showFavoritesPlaylist: boolean,
  showRecentPlaylist: boolean,
): TrackCollection[] => {
  const playlists: TrackCollection[] = [];

  if (showFavoritesPlaylist) {
    playlists.push(buildVirtualPlaylist('favorite-tracks', t));
  }

  if (showRecentPlaylist) {
    playlists.push(buildVirtualPlaylist('recent-tracks', t));
  }

  return playlists;
};

export const buildPersonalPlaylists = (
  playlists: UserPlaylist[],
): TrackCollection[] => {
  return playlists.map(
    (playlist): TrackCollection => ({
      type: 'library',
      title: (playlist as { album_title?: string }).album_title || '',
      id: `playlist/${playlist.id}`,
      imagePath: getRandomDefaultImage(),
      originalPlaylist: playlist,
    }),
  );
};
